import React, { useEffect } from 'react'
import sadFace from 'assets/images/event-sad-face.svg'
import { Button, Container, Modal } from 'react-bootstrap'
import BaseModal from './BaseModal'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import { t } from 'i18next'

function NoTurnPopupModal({
	show,
	onHide,
	data,
	handlePlay,
	handleBuyPackage,
	...otherProps
}) {

  // useEffect(() => {
  //   if (show) {
  //     setTimeout(() => {
  //       onHide()
  //     }, 3000)
  //   }

  //   return () => {
  //     clearTimeout()
  //   }
  // })

	return (
		<BaseModal show={show} onHide={onHide} penalty {...otherProps}>
				<Modal.Header className="py-0">
					<div className="d-flex justify-content-center align-items-center">
						<img src={sadFace} alt="Sad face" className='sad-face-icon' />
					</div>
				</Modal.Header>

				<Modal.Body className="py-0 mt-3">
					<div className="d-flex justify-content-center align-items-center">
						<p className="text-center popup-content-text text-penalty">
							{t('event.boat_racing.popup.no_turn')}
						</p>
					</div>
				</Modal.Body>

				<Modal.Footer className="d-flex justify-content-around align-items-center">
					<Button className="no-turn-popup-btn" onClick={handleBuyPackage}>
						{t('event.boat_racing.popup.buy_package')}
					</Button>
					<Button className="no-turn-popup-btn" onClick={handlePlay}>
						{t('event.boat_racing.popup.play_game')}
					</Button>
				</Modal.Footer>
		</BaseModal>
	)
}

export default NoTurnPopupModal
